import React, { Fragment } from 'react';
import { usePageContext } from 'Context/PageContext';
import { b2cPagesService } from '@clubmed/utils';
import { INLINE_1 } from 'Components/frameworks/card/Card.constants';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import { Card } from 'Components/frameworks/card/Card';
import { Hr } from 'Components/frameworks/hr/Hr';
type ProductCateringProps = {
  intros?: Array<{
    description?: string;
    title?: string;
  }>;
  list?: Array<{
    seminarDescription?: string;
    description?: string;
    image?: string;
    name?: string;
  }>;
  seeLessLabel?: string;
  seeMoreLabel?: string;
};
export const ProductCatering = ({
  intros = [],
  list = [],
  seeLessLabel,
  seeMoreLabel,
}: ProductCateringProps) => {
  const { pageType } = usePageContext();
  const isMicePage = b2cPagesService.isMicePage(pageType);
  const hasIntros = !!intros.length;
  const hasList = !!list.length;

  if (!hasIntros && !hasList) {
    return null;
  }

  return (
    <div className="pb-30" data-testid="ProductCatering">
      {hasIntros && (
        <div className="flex">
          {intros.map(({ description, title = '' }) => (
            <Card
              className="w-full md:w-1/2"
              key={title}
              heading={{
                title,
              }}
              text={{
                text: description,
              }}
            />
          ))}
        </div>
      )}
      {hasIntros && hasList && <Hr className="my-20" />}
      {hasList &&
        list.map(({ description, seminarDescription, image = '', name = '' }, index) => {
          const descriptionToUse = isMicePage ? seminarDescription : description;
          return (
            (descriptionToUse || name) && (
              <Fragment key={name}>
                {index > 0 && <Hr className="my-20" />}
                <Card
                  heading={{
                    title: name,
                  }}
                  layout={INLINE_1}
                  media={{
                    url: image,
                    ratioKey: ratioUtils.M,
                  }}
                  seeLessLabel={seeLessLabel}
                  seeMoreLabel={seeMoreLabel}
                  text={{
                    text: descriptionToUse,
                  }}
                />
              </Fragment>
            )
          );
        })}
    </div>
  );
};
